import { Shell } from "@/components/wizard/shell";

export function ResumeScreen({
	onResume,
	onRestart,
}: {
	onResume: () => void;
	onRestart: () => void;
}) {
	return (
		<Shell>
			<div className="fade-up max-w-xl text-center">
				<h1 className="font-display text-4xl leading-tight text-foreground">
					Você já tinha começado
				</h1>
				<p className="mt-4 text-xl text-muted-foreground">
					Quer continuar de onde parou ou recomeçar do zero?
				</p>
				<div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
					<button
						type="button"
						onClick={onResume}
						className="rounded-full bg-primary px-10 py-4 text-xl font-semibold text-primary-foreground shadow-control transition hover:bg-primary-hover"
					>
						Continuar de onde parei
					</button>
					<button
						type="button"
						onClick={onRestart}
						className="rounded-full border-2 border-foreground/15 px-8 py-4 text-lg font-medium text-foreground transition hover:border-info/60 hover:bg-info/5"
					>
						Começar de novo
					</button>
				</div>
			</div>
		</Shell>
	);
}
